import Breadcrumb from '@/components/breadcrumb';
import { Button } from '@/components/ui/button';
import { useStore } from '@nanostores/react';
import { PlusIcon } from 'lucide-react';
import { NewOrganizationDrawer } from './components/NewOrganizationDrawer';
import { OrganizationListing } from './components/OrganizationListing';

// const adminUids = [
//   'FZZBdSR14QMSBiFjmocb9DJUeiz1',
//   'xKxDFOcRVWTACjwBWVeGbqnd52g2',
//   'Api5p1zCasOWJfTj9U3bzZKf1dm2',
//   'vNGzgHmHnZQaCuye45KlGQFYga52',
//   'HDrhRLeVDeFiMm8OTT0j3fgzQzSu',
// ];

export const ManageOrganizations = () => {
  const [showDrawer, setShowDrawer] = useState(false);
  const user = useStore($user);

  const pages = [
    {
      label: 'Organizations',
      href: '/organizations',
    },
  ];

  return (
    <div>
      {/* Breadcrumb */}
      <h3 className="m-0 flex-1 p-0">
        <Breadcrumb pages={pages} />
      </h3>

      {/* Page Header with actions */}
      <div className=" mt-2 flex items-center justify-between space-y-2">
        <div>
          <h2 className="text-2xl font-bold tracking-tight">Organizations</h2>
          <p className="text-muted-foreground">
            List of organizations you are part of or manage.
          </p>
        </div>
        {/* {user?.uid && adminUids.includes(user.uid) && ( */}
        {user?.uid && (
          <div className="flex items-center space-x-2">
            <Button onClick={() => setShowDrawer(true)}>
              <PlusIcon className="mr-2 h-4 w-4" /> Add New
            </Button>
          </div>
        )}
      </div>

      {/* Organization list */}
      <div className="mt-4 max-w-4xl">
        <OrganizationListing />
      </div>

      {/* Create New Organization Drawer */}
      <NewOrganizationDrawer open={showDrawer} setOpen={setShowDrawer} />
    </div>
  );
};
